<mat-form-field class="w-100">
	<input
		*ngIf="readonly"
		matInput
		readonly
		placeholder="Railroad"
		[value]="railroadName"
		[required]="required"
	/>
	<mat-select
		*ngIf="!readonly"
		[required]="required"
		[formControl]="railroad"
		[compareWith]="idComparer"
		(selectionChange)="optionSelected.emit($event.value)"
		placeholder="Railroad"
	>
		<mat-option>--</mat-option>
		<mat-option
			*ngFor="let railroad of railroads$ | async"
			[value]="railroad"
		>
			{{ displayName(railroad) }}
		</mat-option>
	</mat-select>
	<mat-error>Required</mat-error>
</mat-form-field>
